import type { AuthMode, MeResponse } from '@dashy-dash/shared';
import { useEffect, useState } from 'react';
import { t } from '../i18n';
import { api } from './api';

/** Einmal je Seitenaufruf laden; Sidebar und „Mehr" teilen sich die Antwort. */
let pending: Promise<MeResponse> | null = null;

export function useMe(): MeResponse | null {
  const [me, setMe] = useState<MeResponse | null>(null);
  useEffect(() => {
    let alive = true;
    (pending ??= api<MeResponse>('/api/me')).then((m) => alive && setMe(m)).catch(() => (pending = null));
    return () => {
      alive = false;
    };
  }, []);
  return me;
}

export const AUTH_VIA: Record<AuthMode, string> = { oidc: t('shell.authOidc'), proxy: t('shell.authProxy'), dev: t('shell.authDev') };
